import * as localStorageService from './localStorageService';

export * from './authService';
export * from './userService';
export * from './contentService';
export * from './mediaService';
export * from './productService';
export * from './cartService';
export * from './addressService';
export * from './orderService';
export * from './reviewService';
export * from './paymentService';

export default localStorageService;
